import { render } from "./OptionOffer.vue?vue&type=template&id=4bff9e1e&scoped=true"
import script from "./OptionOffer.vue?vue&type=script&lang=js"
export * from "./OptionOffer.vue?vue&type=script&lang=js"

import "./OptionOffer.vue?vue&type=style&index=0&id=4bff9e1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bff9e1e"]])

export default __exports__